import { WindowLocation } from "@reach/router"
import removeTrailingSlash from "tools/removeTrailingSlash"

export const getSlugFromLocation = (location: WindowLocation) =>
  removeTrailingSlash(location.pathname).substring(
    removeTrailingSlash(location.pathname).lastIndexOf("/") + 1
  )
